import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from "chart.js";
import dayjs from "dayjs";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const UserCreationChart = ({ users }) => {
  const currentYear = dayjs().year();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [{ label: "New Users Added", data: [], borderColor: "rgba(75, 192, 192, 1)", fill: false }]
  });

  const groupUsersByMonth = (users, year) => {
    const months = Array.from({ length: 12 }, (_, i) => i + 1);
    const grouped = Object.fromEntries(months.map(month => [month, 0]));

    users.forEach((user) => {
      const createdAt = dayjs(user.createdAt);
      if (createdAt.year() === year) {
        grouped[createdAt.month() + 1]++;
      }
    });

    return grouped;
  };

  useEffect(() => {
    if (users && users.length > 0) {
      const groupedData = groupUsersByMonth(users, selectedYear);
      const labels = Object.keys(groupedData).map(month => dayjs().month(month - 1).format("MMM"));
      const dataPoints = Object.values(groupedData);

      setChartData({
        labels,
        datasets: [
          {
            label: `Users Created in ${selectedYear}`,
            data: dataPoints,
            borderColor: "rgba(75, 192, 192, 1)",
            fill: false,
            tension: 0.4,
          },
        ],
      });
    }
  }, [users, selectedYear]);

  const options = {
    responsive: true,
    maintainAspectRatio: true, // Allows chart height to be controlled by the height prop
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: false,
        text: `User Created in ${selectedYear}`,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Month",
        },
      },
      y: {
        title: {
          display: true,
          text: "Number of New Users",
        },
        beginAtZero: true,
      },
    },
  };

  const generateYearOptions = () => {
    const startYear = dayjs(users[0]?.createdAt).year();
    const years = [];
    for (let year = startYear; year <= currentYear; year++) {
      years.push(year);
    }
    return years.reverse();
  };

  return (
    <div className="space-y-4">
      <select 
        value={selectedYear} 
        onChange={(e) => setSelectedYear(parseInt(e.target.value))}
        className="p-2 border rounded"
      >
        {generateYearOptions().map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
      <Line data={chartData} options={options} height={250}/>
    </div>
  );
};

export default UserCreationChart;